<template>
  <div>
    <Modal v-model="visible" width="500px" :title="formData.id ? '编辑合同' : '新增合同'" :footer-hide="true" :mask-closable="false" class="my-modal top">
      <Form ref="form" :model="formData" :label-width="100" class="page-form less" v-if="visible">
        <FormItem prop="name" label="合同名称" :rules="$units.formRule.required('请输入')" class="full">
          <Input v-model="formData.name" placeholder="请输入" />
        </FormItem>
        <FormItem prop="uploadFile" label="上传合同文件" :rules="$units.formRule.required('请选择', 'change', 'array')" class="full" :label-width="110">
          <uploadNew v-model="formData.uploadFile" :muti="false" fileType="pdf" @change="fileChange"></uploadNew>
          <span class="file-desc">仅支持pdf格式</span>
        </FormItem>
        <FormItem v-if="$units.isOkBao() || $units.isOkTX()" label="适用对象" prop="templateType" class="full" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.templateType" transfer placeholder="请选择" clearable>
            <Option value="1">代理人</Option>
            <Option value="2">合伙人</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">提交</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <contract-config-success ref="contractConfigSuccess"></contract-config-success>
  </div>
</template>

<script>
import contractConfigSuccess from './contractConfigSuccess';
import uploadNew from '@/components/commons/uploadNew';
export default {
  components: {
    contractConfigSuccess,
    uploadNew
  },
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        signTime: null,
        uploadFile: []
      },
      orgList: []
    };
  },
  created() {},
  methods: {
    open(data = {}, tableItem) {
      if (data.id) {
        this.formData = {
          id: data.id,
          templatId: tableItem.id,
          name: data.name,
          templateType: data.templateType,
          isUpload: 0,
          uploadFile: [
            {
              path: data.uploadFile
            }
          ]
        };
      } else {
        this.formData = {
          templatId: tableItem.id,
          name: '',
          templateType:'',
          uploadFile: []
        };
      }

      this.visible = true;
    },
    submit() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.uploadFile = formData.uploadFile[0].path;
        if (this.loading) {
          return;
        }
        this.loading = true;
        formData.type = this.$route.query.type;
        this.$http({
          type: 'POST',
          url: formData.id ? '/buz/contract/edit' : '/buz/contract/add',
          data: formData
        })
          .then(res => {
            this.$notice.success('提交成功');
            this.visible = false;
            this.$emit('suceess');
            // 新增或者重新上传模板显示
            if (formData.isUpload == 1 || !formData.id) {
              this.$refs.contractConfigSuccess.open();
            }
          })
          .finally(res => {
            this.loading = false;
          });
      });
    },
    // 文件上传
    fileChange() {
      if (this.formData.id) {
        this.formData.isUpload = 1;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.file-desc {
  font-size: 13px;
  color: #999;
}
</style>
